//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'EmailAddresses',
  props: ['name', 'value', 'errors'],
  methods: {
    onInsert() {
      this.value.push({
        type: 'home',
        value: null
      });
      this.$emit('input', this.value);
    },

    onRemove(item) {
      this.$emit('input', this.value.filter(i => i !== item));
    }

  },
  computed: {
    field() {
      return this.name || 'emails';
    },

    getError() {
      return name => {
        if (this.errors) return this.errors && this.errors[name];
        return null;
      };
    }

  }
};